import React from "react";
import { defineMessages } from "react-intl";

import { Price } from "@one.com/react-common/components";
import getWSBPlansFeatures from "./getWSBPlansFeatures";

const messages = defineMessages({
  beginner1: {
    id: "orderflow.upsellProduct.beginner.feature1",
    defaultMessage: "Build your own website",
  },
  beginner2: {
    id: "orderflow.upsellProduct.beginner.feature2",
    defaultMessage: "Email with your own domain name",
  },
  beginner3: {
    id: "orderflow.upsellProduct.beginner.feature3",
    defaultMessage: "Create unlimited email accounts",
  },
  emailEssential1: {
    id: "orderflow.upsellProduct.emailEssential.feature1",
    defaultMessage: "Email with your own domain name",
  },
  emailEssential2: {
    id: "orderflow.upsellProduct.emailEssential.feature2",
    defaultMessage: "Create up to 5 email accounts",
  },
  emailEssential3: {
    id: "orderflow.upsellProduct.emailEssential.feature3",
    defaultMessage: "Get 3 GB storage per account",
  },
  emailUnlimited1: {
    id: "orderflow.AddonProduct.mailstorageunlimited.feature.1",
    defaultMessage: "Email with your own domain name",
  },
  emailUnlimited2: {
    id: "orderflow.AddonProduct.mailstorageunlimited.feature.2",
    defaultMessage: "Create unlimited email accounts",
  },
  emailUnlimited3: {
    id: "orderflow.AddonProduct.mailstorageunlimited.feature.3",
    defaultMessage: "Get unlimited storage",
  },
  msBusinessStandard1: {
    id: "orderflow.AddonProduct.M365businessStandard.feature1",
    defaultMessage: "Email with your own domain name",
  },
  msBusinessStandard2: {
    id: "orderflow.AddonProduct.M365businessStandard.feature2",
    defaultMessage: "Daily email backups",
  },
  msBusinessStandard3: {
    id: "orderflow.AddonProduct.M365businessStandard.feature3",
    defaultMessage: "Work with Microsoft apps on all your devices",
  },
  wsbPremium1: {
    id: "orderflow.AddonProduct.wsb.feature.1",
    defaultMessage: "Build a website with drag and drop",
  },
  wsbPremium2: {
    id: "orderflow.AddonProduct.wsb.feature.2",
    defaultMessage: "Generate a complete website with AI",
  },
  wsbPremium3: {
    id: "orderflow.AddonProduct.wsb.feature.3",
    defaultMessage: "Publish an unlimited amount of pages",
  },
  mWP1: {
    id: "orderflow.AddonProduct.mwp.feature.1",
    defaultMessage: "Advanced security",
  },
  mWP2: {
    id: "orderflow.AddonProduct.mwp.feature.2",
    defaultMessage: "Support from experts",
  },
  mWP3: {
    id: "orderflow.AddonProduct.mwp.feature.3",
    defaultMessage: "Up-to-date and healthy",
  },
  multipleWebsitesSupported: {
    id: "orderflow.upsellProduct.feature.multipleWebsitesSupported",
    defaultMessage: "{websitesSupported} websites supported",
  },
  unlimitedMailAccounts: {
    id: "orderflow.upsellProduct.feature.unlimitedMailAccounts",
    defaultMessage: "Unlimited mail accounts",
  },
  unlimitedMailAccountsWithPremiumFeatures: {
    id: "orderflow.upsellProduct.feature.unlimitedMailAccountsWithPremiumFeatures",
    defaultMessage: "Unlimited mail accounts with premium features",
  },
  websiteBuilder: {
    id: "orderflow.upsellProduct.feature.websiteBuilder",
    defaultMessage: "Website builder",
  },
  oneClickWPInstall: {
    id: "orderflow.upsellProduct.feature.oneClickWPInstall",
    defaultMessage: "1-click WordPress install",
  },
  freeAdvancedWPTools: {
    id: "orderflow.upsellProduct.feature.freeAdvancedWPTools",
    defaultMessage: "Free advanced WordPress tools",
  },
  onlineShop: {
    id: "orderflow.AddonProduct.onlineshop.feature.1",
    defaultMessage: "Sell your products online",
  },
  trackingFeatures: {
    id: "orderflow.AddonProduct.onlineshop.feature.2",
    defaultMessage: "Build a website or shop with drag-and-drop",
  },
  includesAllWSBPremiumFeatures: {
    id: "orderflow.AddonProduct.onlineshop.feature.3",
    defaultMessage: "Publish an unlimited amount of pages",
  },
  dailyMalwareScan: {
    id: "orderflow.AddonProduct.sitelock.feature.1",
    defaultMessage: "Daily malware scan",
  },
  upTo5Pages: {
    id: "orderflow.AddonProduct.sitelock.feature.2",
    defaultMessage: "Up to 5 pages",
  },
  trustSealOnYourWebsite: {
    id: "orderflow.AddonProduct.sitelock.feature.3",
    defaultMessage: "Trust seal on your website",
  },
  businessListingOnGoogle: {
    id: "orderflow.AddonProduct.uberall.feature.1",
    defaultMessage: "Business listing on Google",
  },
  getFoundOnline: {
    id: "orderflow.AddonProduct.uberall.feature.2",
    defaultMessage: "Get found online",
  },
  reachMoreLocalCustomers: {
    id: "orderflow.AddonProduct.uberall.feature.3",
    defaultMessage: "Reach more local customers",
  },
  getAccessToAllDNSSettings: {
    id: "orderflow.AddonProduct.dnsadmin.feature.1",
    defaultMessage: "Prevent unauthorised domain transfers",
  },
  secureYourDomainWithDomainLock: {
    id: "orderflow.AddonProduct.dnsadmin.feature.2",
    defaultMessage: "Protects from hacking and other cybercrime",
  },
  guestUsers: {
    id: "orderflow.AddonProduct.dnsadmin.feature.3",
    defaultMessage: "Secure your domain with auto-renew protection",
  },
  weeklyWebsiteScan: {
    id: "orderflow.AddonProduct.marketgoostart.feature.1",
    defaultMessage: "Weekly website scan",
  },
  fiveKeywordRankingReports: {
    id: "orderflow.AddonProduct.marketgoostart.feature.2",
    defaultMessage: "5 keyword ranking reports",
  },
  twoCompetitorAnalyses: {
    id: "orderflow.AddonProduct.marketgoostart.feature.3",
    defaultMessage: "2 competitor analyses",
  },
  EXCHANGE_ONLINE_1: {
    id: "orderflow.AddonProduct.exchangeOnline.feature.1",
    defaultMessage: "Professional email and calendar",
  },
  EXCHANGE_ONLINE_2: {
    id: "orderflow.AddonProduct.exchangeOnline.feature.2",
    defaultMessage: "Outlook online",
  },
  EXCHANGE_ONLINE_3: {
    id: "orderflow.AddonProduct.exchangeOnline.feature.3",
    defaultMessage: "Free email backup and restore",
  },
  EXCHANGE_M365_BUSINESS_BASIC_1: {
    id: "orderflow.AddonProduct.exchangeBasic.feature.1",
    defaultMessage: "Professional email and calendar",
  },
  EXCHANGE_M365_BUSINESS_BASIC_2: {
    id: "orderflow.AddonProduct.exchangeBasic.feature.2",
    defaultMessage: "Office apps online",
  },
  EXCHANGE_M365_BUSINESS_BASIC_3: {
    id: "orderflow.AddonProduct.exchangeBasic.feature.3",
    defaultMessage: "Free email backup and restore",
  },
  vps: {
    id: "orderflow.package.vps.feature.1",
    defaultMessage:
      "1-month subscription. Billed monthly. 15 days notice period.",
  },
  plesk: {
    id: "orderflow.AddonProduct.plesk.feature",
    defaultMessage:
      "1-month subscription. Billed monthly. 15 days notice period.",
  },
  pleskAdmin: {
    id: "orderflow.AddonProduct.pleskAdmin.feature.1",
    defaultMessage: "Basic management of simple websites and your domains.",
  },
  pleskPro: {
    id: "orderflow.AddonProduct.pleskPro.feature.1",
    defaultMessage:
      "Build, secure and run highly optimised and customised websites.",
  },
  pleskHost: {
    id: "orderflow.AddonProduct.pleskHost.feature.1",
    defaultMessage: "Customise, provision, and manage hosting businesses.",
  },
  vpsWindows: {
    id: "orderflow.AddonProduct.vpsWindows.feature",
    defaultMessage:
      "1-month subscription. Billed monthly. 15 days notice period.",
  },
  vpsBackupBasic: {
    id: "orderflow.AddonProduct.Backups.feature.1",
    defaultMessage: "Daily backups of your VPS you can restore when needed.",
  },
  vpsRebatePrice: {
    id: "orderflow.cartEntry.rebate.vps.info",
    defaultMessage: "First month {rebatePrice}. Renews at {price} /mo.",
  },
});

const VPSWithSupportedRebates = [
  "ONEVPS_SMALL",
  "ONEVPS_MEDIUM",
  "ONEVPS_LARGE",
  "ONEVPS_XLARGE",
  "ONEVPS_XXLARGE",
  "MANAGED_ONEVPS_SMALL",
  "MANAGED_ONEVPS_MEDIUM",
  "MANAGED_ONEVPS_LARGE",
  "MANAGED_ONEVPS_XLARGE",
  "MANAGED_ONEVPS_XXLARGE",
];

const getProductFeatures = (productId, caps = [], prices) => {
  const getSupportedCapacity = (featureType) => {
    const foundCapFeature =
      caps.find((cap) => cap.featureType === featureType) || {};

    return foundCapFeature.featureLimit;
  };

  let vpsMessage = { ...messages.vps };

  if (VPSWithSupportedRebates.includes(productId)) {
    const {
      priceExclVat,
      priceInclVat,
      defaultIncludeVat,
      renewalPriceExclVat,
      renewalPriceInclVat,
      currency,
    } = prices[0];
    const hasRebate =
      priceExclVat !== 0 && priceExclVat !== renewalPriceExclVat;
    if (hasRebate) {
      const rebatePrice = (
        <Price
          amount={defaultIncludeVat ? priceInclVat : priceExclVat}
          currency={currency}
        />
      );

      const price = (
        <Price
          amount={defaultIncludeVat ? renewalPriceInclVat : renewalPriceExclVat}
          currency={currency}
        />
      );

      vpsMessage = {
        ...messages.vpsRebatePrice,
        values: { rebatePrice, price },
      };
    }
  }

  const productFeatures = {
    PPS_EMAIL: [
      { ...messages.emailEssential1 },
      { ...messages.emailEssential2 },
      { ...messages.emailEssential3 },
    ],
    PPS_SMALL: [
      { ...messages.beginner1 },
      { ...messages.beginner2 },
      { ...messages.beginner3 },
    ],
    PPS_MEDIUM: [
      { ...messages.unlimitedMailAccounts },
      { ...messages.websiteBuilder },
      { ...messages.oneClickWPInstall },
    ],
    PPS_LARGE: [
      {
        ...messages.multipleWebsitesSupported,
        values: { websitesSupported: getSupportedCapacity("CAP_DOMAIN") },
      },
      { ...messages.unlimitedMailAccounts },
      { ...messages.oneClickWPInstall },
    ],
    PPS_XXLARGE: [
      {
        ...messages.multipleWebsitesSupported,
        values: { websitesSupported: getSupportedCapacity("CAP_DOMAIN") },
      },
      { ...messages.unlimitedMailAccountsWithPremiumFeatures },
      { ...messages.freeAdvancedWPTools },
    ],
    WEBSITE_BUILDER_PREMIUM: [
      { ...messages.wsbPremium1 },
      { ...messages.wsbPremium2 },
      { ...messages.wsbPremium3 },
    ],
    WEBSITE_BUILDER_ECOMMERCE: [
      { ...messages.onlineShop },
      { ...messages.trackingFeatures },
      { ...messages.includesAllWSBPremiumFeatures },
    ],
    SITELOCK_LITE: [
      { ...messages.dailyMalwareScan },
      { ...messages.upTo5Pages },
      { ...messages.trustSealOnYourWebsite },
    ],
    MARKETGOO_START: [
      { ...messages.weeklyWebsiteScan },
      { ...messages.fiveKeywordRankingReports },
      { ...messages.twoCompetitorAnalyses },
    ],
    UBERALL: [
      { ...messages.businessListingOnGoogle },
      { ...messages.getFoundOnline },
      { ...messages.reachMoreLocalCustomers },
    ],
    WORDPRESS_MANAGED: [
      { ...messages.mWP1 },
      { ...messages.mWP2 },
      { ...messages.mWP3 },
    ],
    DNS_ADMIN: [
      { ...messages.getAccessToAllDNSSettings },
      { ...messages.secureYourDomainWithDomainLock },
      { ...messages.guestUsers },
    ],
    MAIL_STORAGE_UNLIMITED: [
      { ...messages.emailUnlimited1 },
      { ...messages.emailUnlimited2 },
      { ...messages.emailUnlimited3 },
    ],
    EXCHANGE_ONLINE: [
      { ...messages.EXCHANGE_ONLINE_1 },
      { ...messages.EXCHANGE_ONLINE_2 },
      { ...messages.EXCHANGE_ONLINE_3 },
    ],
    EXCHANGE_M365_BUSINESS_BASIC: [
      { ...messages.EXCHANGE_M365_BUSINESS_BASIC_1 },
      { ...messages.EXCHANGE_M365_BUSINESS_BASIC_2 },
      { ...messages.EXCHANGE_M365_BUSINESS_BASIC_3 },
    ],
    EXCHANGE_M365_BUSINESS_STANDARD: [
      { ...messages.msBusinessStandard1 },
      { ...messages.msBusinessStandard2 },
      { ...messages.msBusinessStandard3 },
    ],
    ONEVPS_SMALL: [{ ...vpsMessage }],
    ONEVPS_MEDIUM: [{ ...vpsMessage }],
    ONEVPS_LARGE: [{ ...vpsMessage }],
    ONEVPS_XLARGE: [{ ...vpsMessage }],
    ONEVPS_XXLARGE: [{ ...vpsMessage }],
    MANAGED_ONEVPS_SMALL: [{ ...vpsMessage }],
    MANAGED_ONEVPS_MEDIUM: [{ ...vpsMessage }],
    MANAGED_ONEVPS_LARGE: [{ ...vpsMessage }],
    MANAGED_ONEVPS_XLARGE: [{ ...vpsMessage }],
    MANAGED_ONEVPS_XXLARGE: [{ ...vpsMessage }],
    ONEVPS_PLESK_ADMIN_LICENSE: [
      { ...messages.plesk },
      { ...messages.pleskAdmin },
    ],
    ONEVPS_PLESK_PRO_LICENSE: [{ ...messages.plesk }, { ...messages.pleskPro }],
    ONEVPS_PLESK_HOST_LICENSE: [
      { ...messages.plesk },
      { ...messages.pleskHost },
    ],
    ONEVPS_WINDOWS_LICENSE_SMALL: [{ ...messages.vpsWindows }],
    ONEVPS_WINDOWS_LICENSE_MEDIUM: [{ ...messages.vpsWindows }],
    ONEVPS_WINDOWS_LICENSE_LARGE: [{ ...messages.vpsWindows }],
    ONEVPS_WINDOWS_LICENSE_XXLARGE: [{ ...messages.vpsWindows }],
    ONEVPS_WINDOWS_LICENSE_XLARGE: [{ ...messages.vpsWindows }],
    ONEVPS_BASIC_BACKUP: [
      { ...messages.plesk },
      { ...messages.vpsBackupBasic },
    ],
    WSB_MINI: [...getWSBPlansFeatures("WSB_MINI")],
    WSB_BUSINESS: [...getWSBPlansFeatures("WSB_BUSINESS")],
    WSB_PRO: [...getWSBPlansFeatures("WSB_PRO")],
    WSB_ECOMMERCE: [...getWSBPlansFeatures("WSB_ECOMMERCE")],
  }[productId];

  const isDevelopmentEnvironment = process.env.NODE_ENV === "development";

  if (!productFeatures && isDevelopmentEnvironment) {
    console.warn(
      [
        `WARNING: No product features were assigned to product ID "${productId}"!`,
        "(This warning is only shown in development, not in production)",
      ].join(" "),
    );
  }

  return productFeatures;
};

export default getProductFeatures;
